module.exports = __webpack_public_path__ + "cement/img/关于3.8b4ac787.png";